/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:bed51d48-e359-4eb4-bc53-0d09251dd422",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_FxoAupD8r",
    "aws_user_pools_web_client_id": "2osuaocpmsdhkum8ljvdlbcgc1",
    "oauth": {
        "domain": "hypnotherapy1009850b-1009850b-dev.auth.us-east-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "clearMindsHypnotherapy://",
        "redirectSignOut": "clearMindsHypnotherapy://",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "FACEBOOK",
        "GOOGLE",
        "APPLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "UsersTable-dev",
            "region": "us-east-2"
        },
        {
            "tableName": "ClockUserTable-dev",
            "region": "us-east-2"
        },
        {
            "tableName": "UserAudiosTable-dev",
            "region": "us-east-2"
        },
        {
            "tableName": "HynotherapyCategoriesTable-dev",
            "region": "us-east-2"
        },
        {
            "tableName": "CategoryProgramsTable-dev",
            "region": "us-east-2"
        },
        {
            "tableName": "manager-dev", 
            "region": "us-east-2"
        },
        {
            "tableName": "companyUser-dev",
            "region": "us-east-2"
        },
        {
            "tableName": "SubCategory-dev",
            "region": "us-east-2"
        },
        {
            "tableName": "Favorites-dev",
            "region": "us-east-2"
        },
        {
            "tableName": "CachesTable-dev",
            "region": "us-east-2"
        }
    ],
    "aws_user_files_s3_bucket": "hypnotherapybucket120149-dev",
    "aws_user_files_s3_bucket_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "clearMindsHypnotherapy",
            "endpoint": "https://2i16xoqgq9.execute-api.us-east-1.amazonaws.com",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
